/**
 * Created by zl on 2024年12月30日11:17:33.
 * @desc: 定开点位路由
 * @children Object 动态追加
 * {
 *   path: 'frame random string',
 *   name: '$path',
 *   meta: { roles: 'backend random string', title: '标题' },
 *   component: () => import('@/views/custom/['custom'|'custom-update/custom-update'].vue')
 * }
 */
const DEFAULT_LAYOUT = () => import('@/layout/main-layout.vue');

const FRAME = {
  path: '/frame',
  name: 'frame',
  component: DEFAULT_LAYOUT,
  children: [],
  meta: {
    title: '定开点位',
    requiresAuth: true
  }
};

export default FRAME;
